import { NavLink } from 'react-router-dom';
import { useDataContext } from 'context/DataStoreContext';
import { generalStyle } from 'helper/Style';
import { convertDate } from 'helper/Converter';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import H2 from 'component/part/H2';
import List, { ListIndex } from 'component/part/List';

const relationIndexes: ListIndex[] = [
  { label: '受信日時', key: 'id' },
  { label: 'LINEユーザー名' },
];

const LineRelationList: React.FC = () => {
  const { state } = useDataContext();
  const { list = [] } = state?.lineRelation || {};

  const rows = list.map((item) => [
    convertDate(item.createDatetime),
    <NavLink to={`/line-relation/${item.id}`} css={generalStyle.link}>{item.platformUserName}</NavLink>,
  ]);

  return <Layout>
    <BackLink link='/' label='トップ'></BackLink>
    <H2>LINEユーザー一覧</H2>
    <div css={generalStyle.listLayout}>
      <List type='lineRelation' indexes={relationIndexes} rows={rows} />
    </div>
  </Layout>;
};

export default LineRelationList;
